export const secondsToTime = (secs: number) => {
  let hours = Math.floor(secs / (60 * 60));

  const divisor_for_minutes = secs % (60 * 60);
  let minutes = Math.floor(divisor_for_minutes / 60);

  const divisor_for_seconds = divisor_for_minutes % 60;
  const seconds = Math.ceil(divisor_for_seconds);

  if (seconds > 30) {
    minutes += 1;

    if (minutes == 60) {
      hours += 1;
      minutes = 0;
    }
  }

  return {
    h: hours,
    m: minutes,
  };
};

export const toIsoString = (date: Date) => {
  const string = date.toISOString();

  // Remove trailing Z to convert to ISO local timezone
  return string.substring(0, string.length - 1);
};

export function isNightTime(date: Date): boolean {
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const seconds = date.getSeconds();

  const time = hours * 3600 + minutes * 60 + seconds;

  const start = 20 * 3600;
  const end = 8 * 3600;

  return time >= start || time <= end;
}
